/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h3: "h3",
      ul: "ul",
      li: "li",
      strong: "strong"
    }, props.components), {Q} = _components;
    if (!Q) _missingMdxReference("Q", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Art Investment Gallery auction portal"
      }), "\n", _jsx(Q, {
        title: "What is AIG?",
        children: _jsx(_components.p, {
          children: "Art Investment Gallery is an international online auction portal based in the Czech Republic with branches in several European countries that allows you to auction valuable and high-quality works of art from the comfort of your home in the most advanced online auction portal not only on the Czech market."
        })
      }), "\n", _jsxs(Q, {
        title: "How do AIG auctions work?",
        children: [_jsx(_components.p, {
          children: "Auction items are always listed in separate auction blocks for at least one month. They are arranged one after the other with a time interval based on the total number of items in the auction block, with a minimum interval of 1 minute."
        }), _jsx(_components.p, {
          children: "This allows users to bid as soon as the auction block is made public. The ends of individual auction items are scheduled for one to two days at specific time intervals."
        }), _jsx(_components.p, {
          children: "If a bid is made in the last 3 minutes of the auction, an additional 3 minutes are added to the auction."
        })]
      }), "\n", _jsxs(Q, {
        title: "How does bidding work?",
        children: [_jsxs(_components.p, {
          children: ["Users can bid with a standard bid or a limit bid. All standard and limit bids are made in EUR, and users can set their local currency in ", _jsx(_components.a, {
            href: "/my/settings",
            children: "account settings"
          }), " for an approximate conversion during the auction."]
        }), _jsx(_components.p, {
          children: "To pay for auctioned pieces of art, users can choose the currency (USD, EUR, CZK) in which the invoice will be issued."
        }), _jsx(_components.h3, {
          children: "Standard bid"
        }), _jsxs(_components.p, {
          children: ["If you are the first bidder in the auction, your initial bid may be equal to the starting price. When you make a bid, the system will pre-fill the minimum bid. The minimum bid depends on the current price of the art piece according to the minimum bid chart. You can change your bid as you want, but it has to meet the condition for the minimum bid. Once your bid is confirmed, the price of the artwork will increase to your maximum bid, which you will see in the history of bids for this item, and you will also see if your bid is currently the highest. You can clearly track all the items you are bidding on in your user account in the ", _jsx(_components.a, {
            href: "/my/auctions",
            children: "ongoing auctions"
          }), " section. If your bid is exceeded, you will be informed in an email and a notification on the auctioned item's website."]
        }), _jsx(_components.h3, {
          children: "Limit bid"
        }), _jsx(_components.p, {
          children: "If you set a limit bid, you enter the maximum amount you are willing to bid for the item. The system will then automatically bid the lowest possible bids that ensure your first place in the auction. If your limit bid is exceeded by another bidder, you will receive a notification in an email sent to the email address you provided during your registration."
        }), _jsx(_components.p, {
          children: "All limit bids are marked with a hammer symbol in the bidding history."
        }), _jsx(_components.p, {
          children: "In the event of two equal limit bids by two different users, the system will give preference to the bid of the user who set his limit bid first."
        })]
      }), "\n", _jsxs(Q, {
        title: "How can I participate in an auction?",
        children: [_jsx(_components.p, {
          children: "To participate in an auction, a user must create a 'user account' that must be activated and then verified."
        }), _jsx(_components.p, {
          children: "After you fill in all the required information, you will receive an email with a link to verify your account. Once your email address is verified, your account for signing into the AIG portal will be activated. Once the account is activated, the user can browse all the items offered in the auction, along with the history of bids and results from previous auctions."
        }), _jsx(_components.p, {
          children: "To be able to bid in a current auction, a user must verify his account in the user section with an identity card (ID card, passport) via the 'Veriff' verification service."
        })]
      }), "\n", _jsxs(Q, {
        title: "How do I know when my account is verified and ready for bidding?",
        children: [_jsx(_components.p, {
          children: "In your user account under the [user data] tab, you will find the profile verification section (/my/account#verification), where you will find the current verification status of your account."
        }), _jsxs(_components.p, {
          children: ["If there is a delay in the processing of your documents, please write to us at ", _jsx(_components.a, {
            href: "mailto:podpora@artinvestmentgallery.com",
            children: "podpora@artinvestmentgallery.com"
          }), "."]
        })]
      }), "\n", _jsxs(Q, {
        title: "I'm logged in but I can't place a bid.",
        children: [_jsx(_components.p, {
          children: "If you are logged in but you can't place a bid, make sure your account is verified on the basis of an ID document."
        }), _jsxs(_components.p, {
          children: ["You can verify your identity with the 'Veriff' authentication service, which you will find in your account settings under the ", _jsx(_components.a, {
            href: "/my/account",
            children: "user data - profile verification"
          }), " tab."]
        }), _jsx(_components.p, {
          children: "Here you can also track the status of your verification."
        }), _jsxs(_components.p, {
          children: ["If your profile is verified but you still cannot bid, please write to us at ", _jsx(_components.a, {
            href: "mailto:podpora@artinvestmentgallery.com",
            children: "podpora@artinvestmentgallery.com"
          }), "."]
        })]
      }), "\n", _jsxs(Q, {
        title: "Why are bids only made in EUR?",
        children: [_jsx(_components.p, {
          children: "Because AIG has international clientele, unlike other Czech auctions, we decided to only auction in the EUR currency in order to avoid potential complications in currency conversions and different minimum bid amounts."
        }), _jsx(_components.p, {
          children: "However, you can set your default currency (EUR, USD, CZK) in your user account settings and the system will show you an approximate conversion in the currency of your choice according to the current exchange rate."
        })]
      }), "\n", _jsx(Q, {
        title: "Why don't auctions end precisely at the established time?",
        children: _jsx(_components.p, {
          children: "If a user makes a bid in the last three minutes of the auction, the system automatically resets the timer to 00:03:00 to give other users the opportunity to make another bid."
        })
      }), "\n", _jsxs(Q, {
        title: "How can I change my limit bid?",
        children: [_jsx(_components.p, {
          children: "You can lower or raise your set limit by entering a new limit for the auctioned item."
        }), _jsx(_components.p, {
          children: "If you want to lower your limit bid, the limit must not be lower than the current price of the artwork and the minimum bid."
        }), _jsx(_components.p, {
          children: "To increase the limit bid, simply enter a new, higher price."
        }), _jsx(_components.p, {
          children: "If you are in the lead in the auction and you set a new limit, the system will save your limit but will not overbid your bid."
        })]
      }), "\n", _jsxs(Q, {
        title: "Where can I learn more about a specific item in a current auction?",
        children: [_jsx(_components.p, {
          children: "All basic information about an auctioned item, such as its dimensions, dating, signature, technique, condition and an additional description, can be found on the item's detail page."
        }), _jsxs(_components.p, {
          children: ["However, if you want to know more, please contact us via the contact form on the ", _jsx(_components.a, {
            href: "/contact",
            children: "Contact"
          }), " page."]
        })]
      }), "\n", _jsxs(Q, {
        title: "Can I view auctioned items in person?",
        children: [_jsx(_components.p, {
          children: "Yes. You can come and see currently auctioned items in person in a pre-auction exhibition, which is announced in advance on the AIG web portal as well as in an email invitation sent to all registered users."
        }), _jsx(_components.p, {
          children: "If you are unable to attend the pre-auction exhibition, you can view the currently auctioned items in a virtual tour."
        })]
      }), "\n", _jsx(Q, {
        title: "What should I do if I win an auction?",
        children: _jsx(_components.p, {
          children: "If you win an auction, which you will be informed of in an email, the system will enable you to place an order. In your user profile, go to the 'auctioned items' section, select the auctioned items and create an order. In your order you will choose the delivery and payment method."
        })
      }), "\n", _jsx(Q, {
        title: "Can I cancel my bid?",
        children: _jsx(_components.p, {
          children: "You cannot. All bids are binding and they cannot be cancelled."
        })
      }), "\n", _jsx(Q, {
        title: "How can I view items I am currently bidding on?",
        children: _jsx(_components.p, {
          children: "You can easily view all currently auctioned items that you are bidding on in the 'ongoing auctions' section."
        })
      }), "\n", _jsxs(Q, {
        title: "Can I receive notifications of selected items or artists?",
        children: [_jsx(_components.h3, {
          children: "Tracking an item"
        }), _jsx(_components.p, {
          children: "If you want to track the price of a currently auctioned item, click on 'track item' on the auctioned items detail page. If the price changes, you will receive an email notifying you of the development of the price of the item you are tracking and the number of bidders."
        }), _jsx(_components.p, {
          children: "You will also be notified of the approaching end of the auction of the tracked item."
        }), _jsx(_components.h3, {
          children: "Tracking an artist"
        }), _jsx(_components.p, {
          children: "If you want to track a specific artist and receive email notifications about auctions of his work or commission sales, click on 'track artist' on the artist's detail page."
        }), _jsx(_components.p, {
          children: "You can manage all your tracked artists and items in your user account under the 'tracked items' tab."
        })]
      }), "\n", _jsxs(Q, {
        title: "What if I win an auction but I don't want the auctioned item?",
        children: [_jsx(_components.p, {
          children: "As all bids made by users are binding and they cannot be cancelled, the buyer is obliged to pay for the auctioned item and pick it up."
        }), _jsx(_components.p, {
          children: "In the event of non-compliance with the terms and conditions and failure to pay the full price of the auctioned item, including the auction surcharge, the auction operator is entitled to withdraw from the purchase contract, place the auctioned item in another auction and demand 30% of the auctioned price from the buyer."
        })]
      }), "\n", _jsx(_components.h1, {
        children: "Shipping / payment / fees"
      }), "\n", _jsx(Q, {
        title: "Do I have to pay for an auctioned item in EUR?",
        children: _jsx(_components.p, {
          children: "No, you don't. Only bids are made in EUR on the AIG portal. When a user wins an auction, he can choose the currency in which he wants the invoice issued when placing the order."
        })
      }), "\n", _jsx(Q, {
        title: "What types of auction surcharges and fees are associated with auctions?",
        children: _jsx(_components.p, {
          children: "A 20% auction surcharge is added to the final price of each auctioned item; this surchage includes all commissions and fees associated with the auction of the item."
        })
      }), "\n", _jsxs(Q, {
        title: "How can I pay for an auctioned/purchased item?",
        children: [_jsx(_components.p, {
          children: "When you place an order for an item auctioned or purchased by you, you can choose your preferred payment method."
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Cash payment upon pick up (according to the law, this is only possible for items whose price is up to CZK 270,000, i.e. about EUR 10,000)"
          }), "\n", _jsx(_components.li, {
            children: "By bank transfer"
          }), "\n", _jsx(_components.li, {
            children: "Payment in one of the supported cryptocurrencies via the Coinbase payment gateway"
          }), "\n"]
        })]
      }), "\n", _jsxs(Q, {
        title: "How can purchased art be shipped/picked up?",
        children: [_jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Pick-up in person at a branch in the Czech Republic"
          }), " – when your purchased artwork is ready to be picked up, you will receive an email inviting you to pick it up. We recommend that you contact us and arrange a date for picking the artwork up to speed up the process."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Pick-up in person at a branch outside the Czech Republic"
          }), " – when your purchased artwork is ready to be picked up, you will receive an email inviting you to pick it up. You will be charged a flat fee of EUR 100/artwork for the delivery of the artwork to a selected branch outside the Czech Republic."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Delivery to an address in the Czech Republic"
          }), " - we deliver sold artwork within the Czech Republic free of charge to the address you provided in your order. After your payment is credited to our account, we will contact you and arrange a delivery date."]
        }), _jsx(_components.p, {
          children: "** Delivery to an address outside the Czech Republic** - we use an external transport service to deliver auctioned art outside the CR for a flat fee of 100 EUR/piece of art. After the payment is credited to our account, we will prepare the item for transport and the carrier will inform you of the date of its delivery."
        })]
      }), "\n", _jsx(_components.h1, {
        children: "For sellers"
      }), "\n", _jsxs(Q, {
        title: "How can I offer art for an auction, commission sale or purchase?",
        children: [_jsx(_components.p, {
          children: "If you want to offer art you own for our online auction, use the 'offer form' on the AIG website. Click on the 'offer artwork' link on the"
        }), _jsx(_components.p, {
          children: "homepage. Here you will fill in the required information about the artwork and attach photographs."
        }), _jsx(_components.p, {
          children: "Let us know in the note whether you want to offer the art for auction or commission sale, or if you want to sell it to us, and confirm the submission of the form."
        })]
      }), "\n", _jsx(Q, {
        title: "What fee will I have to pay for the acceptance of my art into an auction?",
        children: _jsx(_components.p, {
          children: "The auction commission paid by the seller is not fixed. This fee is arranged in advance or according to the price of the auctioned art. However, the auction commission is a maximum of 10% of the sale price, which is still the lowest auction commission for sellers on the market."
        })
      }), "\n", _jsxs(Q, {
        title: "What do I do if nobody bids on my artwork?",
        children: [_jsx(_components.p, {
          children: "If the artwork offered by you is not auctioned, you can place it in a post-auction sale for a period of 30, 60 or 90 days. The artwork will not be auctioned here, it will be offered at a fixed price that you arrange with us."
        }), _jsx(_components.p, {
          children: "All users will also be able to offer a price they are willing to pay for the art. We will inform you of these offers while the artwork is up for sale."
        })]
      }), "\n", _jsxs(Q, {
        title: "I want to sell an item, but I don't want to place it in an auction.",
        children: [_jsx(_components.p, {
          children: "If you want to sell your art, but you don't want to auction it due to the uncertain final price, you can offer the item for commission sale. Your art will be offered for a fixed purchase price for the arranged period. All users will also be able to offer a price they are willing to pay for the artwork. We will inform you of these offers while the item is up for sale."
        }), _jsx(_components.p, {
          children: "If you don't want to wait for the artwork to be sold, you can sell it to us."
        }), _jsx(_components.p, {
          children: "The same rates apply to both commission sale and online auctions. The seller pays the agreed % of the price of the artwork, but no more than 10%."
        })]
      }), "\n", _jsx(Q, {
        title: "When will I get the money for my artwork sold in an auction?",
        children: _jsx(_components.p, {
          children: "You will receive your money from an online auction of your art 15 to 30 days after the end of the auction (depending on how fast the buyer sends the payment and how fast it is processed by us)."
        })
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
